import React,{ useState, useEffect } from 'react';
import styled from '@emotion/styled';
import Phrase from './components/Phrase';

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Button = styled.button`
  background-color: #fcf361;
  background-size: 18.75em;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  margin: 2rem;
  margin-bottom: 2rem;
  padding: 1rem 2rem;
  font-size: 2rem;
  border: 3px solid black;
  font-weight: lighter;
  transition: background-size .8s ease;

  @media (max-width: 700px){
    font-size: 1.5rem;
    margin-bottom: 0rem;
  }

  :hover{
    cursor: pointer;
    background-color: #d4cc54;
  }
`;

function App() {

  const [ phrase, getPhrase ] = useState({});

  const consultAPI = async () => {
    const api = await fetch('https://thesimpsonsquoteapi.glitch.me/quotes');
    const phrase = await api.json()
    getPhrase(phrase[0]);
  }

  useEffect( () => {
    consultAPI()
  }, []);

  return (
    <Container>

      <Phrase 
        phrase={phrase}
      />
    
      <Button
        onClick={consultAPI}
      >
        Get a quote!
      </Button>
    </Container>
  );
}

export default App;
